<template>
  <div class="breast-implants-chart graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">Breast implant companies buried evidence of injuries for years</h3>
    <p v-if="showDeck">Incidents were reported as routine events that did not require public disclosure. After the FDA tightened enforcement of its reporting rules in 2017, reports of injuries soared.</p>
    <stacked-column-chart :chart-height-ratio="baseHeightRatio" :chart-data="data" :chart-options="options"></stacked-column-chart>
    <p class="chart-source">Source: U.S. Food and Drug Administration, ICIJ analysis</p>
  </div>
</template>

<script>
  import * as d3 from 'd3'
  import data from '../assets/breast-implants-stacked.json'
  import StackedColumnChart from '@/components/StackedColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'BreastImplantsChart',
    mixins: [embeddable],
    components: {
      StackedColumnChart,
    },
    data() {
      return {
        data,
        options: {
          chartName: "breastImplantsStacked",
          barColors: ["#A83324", "#F8B700", "#3B98AB"],
          keys: ["death", "injury", "malfunction"],
          labelWidth: "45",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: function(d) {return d === 0 ? d : d3.format(",.2r")(d);},
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
